import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Icon from 'components/DesignSystem/Icon';
import { FluxAboutDocument } from 'types/Flux/About/fluxAboutDocument';

import './index.scss';

export default function AboutRow({ document, onEdit, onDelete }: {
  document: FluxAboutDocument,
  onEdit: (doc: FluxAboutDocument) => void,
  onDelete: (doc: FluxAboutDocument) => void,
}) {
  const navigate = useNavigate();

  return (
    <div>
      <Row className="w-100 align-items-center about-row py-2 px-3">
        <Col md="1">{document.id}</Col>
        <Col md="3">{document.titulo}</Col>
        <Col md="3">{document.descricao}</Col>
        <Col md="2">{document.autor}</Col>
        <Col md="1">{document.ordem}</Col>
        <Col md="2" className="d-flex gap-2">
          <button
            type="button"
            className="btn btn-sm btn-outline-primary"
            onClick={() => onEdit(document)}
            aria-label="Editar"
          >
            <Icon iconType="edit" size="small" />
          </button>
          <button
            type="button"
            className="btn btn-sm btn-outline-danger"
            onClick={() => onDelete(document)}
            aria-label="Deletar"
          >
            <Icon iconType="trash" size="small" />
          </button>
          <button
            type="button"
            className="btn btn-sm btn-outline-secondary"
            onClick={() => navigate(`/flux/about?tab=${document.id}`)}
            aria-label="Visualizar documento"
            title="Visualizar documento"
          >
            <Icon iconType="open_in_new" size="small" />
          </button>
        </Col>
      </Row>
      <hr className="admin-table-hr" />
    </div>
  );
}
